import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  SITES_LABEL,
} from '../legal/operator';

export default function PrivacyPage() {
  return (
    <LegalDoc title="Политика обработки персональных данных">
      <p>
        Настоящая Политика определяет порядок обработки и защиты персональных данных
        пользователей сайтов {SITES_LABEL} (далее — Сайт) в соответствии с Федеральным
        законом от 27.07.2006 № 152-ФЗ «О персональных данных».
      </p>
      <p>
        Актуальная редакция: {POLICY_DATE}.
      </p>

      <h2>1. Оператор</h2>
      <p>
        Оператор персональных данных: {OPERATOR_NAME}.
      </p>
      <ul>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>ОГРНИП: {OPERATOR_OGRNIP}</li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Электронная почта для запросов субъектов ПДн:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>
      <p>
        Почтовый адрес для запросов на бумаге не публикуется: направляйте обращения
        на указанную электронную почту. Ответ направляется на адрес, с которого
        получен запрос, либо на email учётной записи.
      </p>

      <h2>2. Какие данные обрабатываются</h2>
      <p>В зависимости от того, чем вы пользуетесь, могут обрабатываться:</p>
      <h3>2.1. Регистрация и вход</h3>
      <ul>
        <li>имя;</li>
        <li>имя пользователя (логин) — персональные данные;</li>
        <li>адрес электронной почты — персональные данные;</li>
        <li>пароль (хранится в виде криптографического хеша);</li>
        <li>предпочтительный канал связи (Telegram, email, «Макс»);</li>
        <li>факт и дата согласия на обработку персональных данных.</li>
      </ul>
      <h3>2.2. Профиль (заполняете сами, не обязательно для входа)</h3>
      <ul>
        <li>фамилия, отчество;</li>
        <li>телефон, имя пользователя Telegram;</li>
        <li>город, школа, класс;</li>
        <li>роль на Сайте (ученик, родитель, преподаватель);</li>
        <li>аватар, если загружен;</li>
        <li>настройки редактора кода.</li>
      </ul>
      <h3>2.3. Анкета ученика</h3>
      <ul>
        <li>цель подготовки (ОГЭ / ЕГЭ и год сдачи);</li>
        <li>целевые баллы;</li>
        <li>отношение к домашним заданиям и загруженность;</li>
        <li>отношение к групповым занятиям;</li>
        <li>сведения о финансовых возможностях семьи;</li>
        <li>свободный комментарий.</li>
      </ul>
      <h3>2.4. Обучение</h3>
      <ul>
        <li>решения задач (код, статус проверки, самооценка, комментарии);</li>
        <li>прогресс, списки заданий, журнал занятий;</li>
        <li>
          сведения о присутствии на странице работы (какая задача открыта, время
          последней активности) — чтобы преподаватель видел ход занятия;
        </li>
        <li>содержимое совместного редактора и состав участников сессии;</li>
        <li>сообщения в обсуждениях задач, если вы их пишете.</li>
      </ul>
      <h3>2.5. Оплата</h3>
      <ul>
        <li>сумма и статус платежа;</li>
        <li>email для чека;</li>
        <li>идентификаторы платежа в Озон Пай;</li>
        <li>состав семейного счёта (кто к нему привязан).</li>
      </ul>
      <h3>2.6. Технические данные</h3>
      <ul>
        <li>файлы cookie сессии и защиты форм (см. раздел 5);</li>
        <li>
          IP-адрес, сведения о браузере и запросах — в журналах веб-сервера в объёме,
          необходимом для безопасности и диагностики.
        </li>
      </ul>

      <h2>3. Цели обработки</h2>
      <ul>
        <li>регистрация, вход и ведение учётной записи;</li>
        <li>
          оказание услуг по подготовке к ОГЭ/ЕГЭ: занятия, задания, проверка кода,
          журнал, связь преподавателя с учеником;
        </li>
        <li>
          анкета — чтобы преподаватель подобрал формат занятий; не нужна для самого
          входа на Сайт;
        </li>
        <li>приём оплаты и учёт баланса;</li>
        <li>обеспечение работы и безопасности Сайта;</li>
        <li>исполнение требований законодательства РФ (в том числе учёт расчётов).</li>
      </ul>

      <h2>4. Правовые основания</h2>
      <p>Обработка осуществляется:</p>
      <ul>
        <li>
          для исполнения{' '}
          <Link to={OFERTA_PATH}>договора-оферты</Link>{' '}
          (учётная запись, обучение, оплата, связь по выбранному каналу);
        </li>
        <li>
          на основании{' '}
          <Link to="/consent">согласия</Link> субъекта — в части, которая шире договора
          (в том числе анкета с вопросом о финансовых возможностях);
        </li>
        <li>для исполнения обязанностей, предусмотренных законом.</li>
      </ul>

      <h2>5. Cookie и локальные данные браузера</h2>
      <p>
        Сайт использует только необходимые cookie: идентификатор сессии (вход) и
        токен защиты форм (CSRF). Без них личный кабинет не работает. Аналитических
        и рекламных cookie, Яндекс.Метрики и Google Analytics нет. При первом
        посещении показывается уведомление; необходимые cookie ставятся и до нажатия
        «Понятно», иначе нельзя войти.
      </p>
      <p>
        В localStorage браузера могут сохраняться тема оформления и черновики
        редактора — это остаётся на вашем устройстве, пока вы сами не очистите данные
        сайта.
      </p>
      <p>
        Отключить cookie можно в настройках браузера; вход и отправка форм при этом
        перестанут работать.
      </p>

      <h2>6. Передача третьим лицам</h2>
      <p>Данные не продаются. Передаются только тем, без кого Сайт не работает:</p>
      <ul>
        <li>
          хостинг: ООО «Мастерхост», дата-центр в Москве (хранение сайта и базы
          данных на территории РФ);
        </li>
        <li>
          Озон Пай — при пополнении баланса (email для чека, сумма, назначение
          платежа);
        </li>
        <li>
          почтовый сервис (как правило, Яндекс) — письма о регистрации и анкете
          преподавателю;
        </li>
        <li>
          Telegram или «Макс» — только если вы сами указали этот канал и контакт;
          серверы Telegram могут находиться за пределами РФ;
        </li>
        <li>
          при запуске кода Python в браузере среда выполнения может загружаться с CDN
          jsdelivr.net (технические данные: IP, User-Agent).
        </li>
      </ul>
      <p>
        Также данные могут быть предоставлены по законному требованию государственных
        органов РФ.
      </p>

      <h2>7. Место и срок хранения</h2>
      <p>
        Первичный сбор, запись и хранение персональных данных граждан РФ выполняются
        на серверах на территории Российской Федерации.
      </p>
      <p>
        Данные учётной записи хранятся, пока она действует, либо до отзыва согласия /
        требования об удалении, если более длительный срок не установлен законом
        (например, сведения об оплате). Резервные копии базы уничтожаются по мере
        ротации.
      </p>

      <h2>8. Права пользователя</h2>
      <p>
        Вы вправе запросить доступ, уточнение, блокирование или удаление своих
        персональных данных, а также отозвать согласие. Для этого напишите на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        {' '}с адреса, указанного в профиле, либо приложите данные, по которым можно
        опознать учётную запись.
      </p>
      <p>
        Факт согласия при регистрации фиксируется: время, IP-адрес, версия текста
        согласия. Часть сведений можно изменить самостоятельно в разделе «Профиль».
        Удаление аккаунта по кнопке на Сайте пока не сделано: запрос выполняется по
        почте.
      </p>

      <h2>9. Несовершеннолетние</h2>
      <p>
        Сайт используется для подготовки школьников к ОГЭ и ЕГЭ. Если вам нет 18 лет,
        согласие на обработку персональных данных даёт законный представитель.
        Регистрируясь, вы подтверждаете, что вам есть 18 лет либо законный
        представитель дал согласие на использование Сайта.
      </p>

      <h2>10. Изменения политики</h2>
      <p>
        Актуальная редакция всегда доступна на этой странице. Дата редакции указана
        в начале документа.
      </p>
    </LegalDoc>
  );
}
